import { CustomException } from '@tencent/ppd-base-libs';
import Cookies from 'js-cookie';

/**
 接入新页面的时候需要注意：
 如果该页面不是钱包uin的业务（cookie里没有qluin），
 那么需要让后端在登录cgi中添加set-cookie: wallet_openid
 */
export const getUin = (): string => {
  const wphkUin = Cookies.get('wallet_openid');
  const qlUin = Cookies.get('qluin');
  if (wphkUin && qlUin && wphkUin !== qlUin) {
    new CustomException({ wphkUin, qlUin }, 'dpLoader-UinNotMatch', 'wallet_openid和qluin不一致');
  }
  return wphkUin || qlUin;
};

/**
 * 检查uin是否为空或者不符合钱包uin格式
 */
export const isValidUinFormat = (uin = '') => {
  const reg = new RegExp('^[a-zA-Z0-9_-]{28}@wx.hkg$');
  const result = reg.exec(uin);
  return !!result;
};
